"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContainerDimensions = void 0;
var _react = require("react");
const useContainerDimensions = ref => {
  const [dimensions, setDimensions] = (0, _react.useState)({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0
  });
  const getDimensions = (0, _react.useCallback)(() => ({
    width: ref.current?.offsetWidth || 0,
    height: ref.current?.offsetHeight || 0,
    top: ref.current?.offsetTop || 0,
    left: ref.current?.offsetLeft || 0,
    bottom: Number(ref.current?.offsetTop) + Number(ref.current?.offsetHeight) || 0
  }), [ref]);
  (0, _react.useEffect)(() => {
    const handleResize = () => setDimensions(getDimensions());
    if (ref.current) setDimensions(getDimensions());
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [getDimensions, ref]);
  return dimensions;
};
exports.useContainerDimensions = useContainerDimensions;